import { resolveAppStatsFeature } from '~/constants/appStatsFeatures'
import { useApiMonOrga } from '~/composables/api/useApiMonOrga'

/**
 * Envoie une page vue stats à chaque navigation (fire-and-forget).
 */
export default defineNuxtPlugin((nuxtApp) => {
  const { loggedIn } = useOidcAuth()
  const router = useRouter()

  async function sendPageView(routeName: string | null | undefined): Promise<void> {
    if (!loggedIn.value) {
      return
    }
    const name = (routeName ?? '').trim()
    if (!name) {
      return
    }
    try {
      await useApiMonOrga('POST', '/v1/stats/page-view', undefined, {
        routeName: name.slice(0, 160),
        feature: resolveAppStatsFeature(name),
      })
    } catch {
      // jamais bloquant
    }
  }

  nuxtApp.hook('page:finish', () => {
    void sendPageView(router.currentRoute.value.name?.toString() ?? null)
  })
})
